import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

// AuthGuard für authenticated-only Routes.
// Wenn keine Session → redirect zu /login mit `from`-State damit nach Login
// zurück zum gewünschten Pfad navigiert werden kann.
export function AuthGuard() {
  const { session, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    // Während Hydration: neutraler Block, kein Flash zu Login
    return <div className="min-h-screen bg-base" aria-busy="true" />;
  }

  if (!session) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
